import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { LayoutAuthSettingsShared } from 'src/app/components/shared/models/interface/layoutAuthSettings.interface';

@Injectable({
  providedIn: 'root',
})
export class LayoutAuthService<FlagType> {
  private currentSettings: LayoutAuthSettingsShared<FlagType>;
  private settingsSubject: Subject<LayoutAuthSettingsShared<FlagType>> = new Subject<LayoutAuthSettingsShared<FlagType>>();
  private settings$: Observable<LayoutAuthSettingsShared<FlagType>> = this.settingsSubject.asObservable();

  constructor() {
    /** */
  }

  setSettings(settings: LayoutAuthSettingsShared<FlagType>) {
    this.settingsSubject.next(settings);
  }

  get settings(): Observable<LayoutAuthSettingsShared<FlagType>> {
    return this.settings$;
  }

  updateSettings(newSettings: LayoutAuthSettingsShared<FlagType>): void {
    this.setSettings({ ...this.currentSettings, ...newSettings });
  }
}
